// Clinical reference curves (approximate landmark values from published sources —
// Fenton 2013 for preterm growth, Bhutani for bilirubin nomogram). Values are used
// only for visual overlay on patient trends; not intended for automated dosing.

// PMA weeks vs weight in grams (average of boys/girls, 3rd / 50th / 97th percentile)
export const FENTON_WEIGHT = [
  { pma: 22, p3: 380, p50: 490, p97: 590 },
  { pma: 24, p3: 540, p50: 660, p97: 800 },
  { pma: 26, p3: 700, p50: 880, p97: 1080 },
  { pma: 28, p3: 900, p50: 1120, p97: 1370 },
  { pma: 30, p3: 1180, p50: 1450, p97: 1780 },
  { pma: 32, p3: 1500, p50: 1830, p97: 2190 },
  { pma: 34, p3: 1830, p50: 2210, p97: 2620 },
  { pma: 36, p3: 2160, p50: 2600, p97: 3060 },
  { pma: 38, p3: 2450, p50: 2960, p97: 3450 },
  { pma: 40, p3: 2680, p50: 3260, p97: 3800 },
  { pma: 42, p3: 2820, p50: 3450, p97: 4020 },
];

// Age in hours vs total serum bilirubin (mg/dL), Bhutani nomogram
// low-intermediate (40th), high-intermediate (75th), high-risk (95th)
export const BHUTANI = [
  { hr: 12, p40: 4.0, p75: 5.5, p95: 7.5 },
  { hr: 24, p40: 5.5, p75: 7.5, p95: 10.5 },
  { hr: 36, p40: 7.0, p75: 10.0, p95: 13.0 },
  { hr: 48, p40: 8.0, p75: 12.0, p95: 15.0 },
  { hr: 60, p40: 9.0, p75: 13.0, p95: 17.0 },
  { hr: 72, p40: 10.0, p75: 13.5, p95: 18.0 },
  { hr: 84, p40: 10.5, p75: 14.0, p95: 18.5 },
  { hr: 96, p40: 11.0, p75: 14.0, p95: 19.0 },
  { hr: 108, p40: 11.0, p75: 14.0, p95: 19.0 },
  { hr: 120, p40: 11.0, p75: 14.0, p95: 19.0 },
];
